import React from 'react'
import { FormControl, Input, InputLabel } from '@mui/material'
import { FormControlProps } from '@mui/material/FormControl/FormControl'

import { StateTitle, StateValues } from '../../constants/localization/states'
import { CountryCode } from '../../types'
import PuiSelect, { PuiSelectProps } from './PuiSelect'

export const getStateTitle = (country: CountryCode) => StateTitle[country]

export interface StateSelectProps extends Omit<PuiSelectProps, 'margin'> {
  readonly country?: CountryCode
  readonly hideLabel?: boolean
  readonly margin?: FormControlProps['margin']
}

const StateSelect = ({
  required,
  className,
  field,
  country = CountryCode.US,
  margin = 'normal',
  hideLabel,
  ...rest
}: StateSelectProps) => (
  <FormControl
    fullWidth
    className={className}
    error={field && !field.valid}
    margin={margin}
  >
    {!hideLabel && (
      <InputLabel htmlFor="state-select">
        {`${getStateTitle(country)}${required ? '*' : ''}`}
      </InputLabel>
    )}
    <PuiSelect
      field={field}
      input={<Input id="state-select" />}
      items={StateValues[country]}
      {...rest}
    />
  </FormControl>
)

export default StateSelect
